<template>
  <div>
    <!-- Contenedor de Preferencias Iniciales -->
    <div class="tw-fixed tw-inset-0 tw-z-50" style="background-color: var(--bg-main);" v-if="mostrar">
      <Preferencias />
    </div>

    <!-- Contenedor Principal del Dashboard -->
    <div v-if="!mostrar" class="tw-min-h-screen tw-flex" style="background-color: var(--bg-main); transition: background-color 0.3s ease;">
      <!-- Slim Sidebar (64px) - Only for logged in users -->
      <NavBarV v-if="isLoggedIn" />

      <!-- Main Content Column -->
      <div class="tw-flex-1 tw-min-w-0 tw-flex tw-flex-col tw-relative tw-z-[5]">
        <!-- Topbar -->
        <TopBar />

        <!-- Page Content -->
        <main class="tw-p-3 tw-pb-0 md:tw-p-4 md:tw-pb-0 tw-flex tw-flex-col tw-flex-1">
          <div class="tw-flex-1 tw-rounded-t-2xl tw-border-t tw-border-l tw-border-r tw-shadow-[0_12px_32px_rgba(0,0,0,0.22)] tw-overflow-y-auto tw-transition-colors tw-duration-300 tw-flex tw-flex-col" style="background-color: var(--card-bg); border-color: var(--border-color);">
            <div class="tw-p-4 md:tw-p-8 tw-flex-1 tw-flex tw-flex-col">
              <router-view class="tw-flex-1" />
            </div>
            <FooterV />
          </div>
        </main>
      </div>
    </div>

  </div>
</template>

<script>
import NavBarV from "@/components/Navbar/NavBarV.vue";
import TopBar from "@/components/Navbar/TopBar.vue";
import Preferencias from "@/views/content/preferences/PreferenceCateg.vue";
import FooterV from "@/components/Footer/FooterV.vue";
import { mapState } from "vuex";
import { authGet } from "@/helpers/authStorage";

export default {
  name: "Contenedor",
  components: {
    NavBarV,
    TopBar,
    Preferencias,
    FooterV,
  },
  data() {
    return {
      mostrar: false,
      status_user: null,
      isLoggedIn: false,
    };
  },
  computed: {
    ...mapState("course", ["courseHover"]),
  },
  created() {
    this.status_user = authGet("status_preference");
    if (this.status_user == 0) {
      this.mostrar = !this.mostrar;
    }
    this.isLoggedIn = !!authGet("access_token");
  },
};
</script>

<style scoped>
/* Sin Vuetify ni Bootstrap. Todo nativo con TailwindCSS */
</style>
